export function getCookie(name) {
  if (window.document.cookie) {
    const match = document.cookie.split("; ").find((row) => row.startsWith(`${name}=`))

    if (match) {
      return match.split("=")[1]
    }

    return ""
  }

  return ""
}
